export const experience = [
  {
    duration: "2021 Aug - present",
    position: "Software Engineer",
    description: "Working as full-time junior software engineer, (React.js)",
    workPlace: "EPAM Systems",
  },
  {
    duration: "07/07/2021 - 01/30/2022",
    position: "Front End Developer",
    description: "working as part-time Front end Developer (React.js)",
    workPlace: "CROSSCREATORS (crosscreators.com)",
  },
  {
    duration: "02/15/2021 - 05/29/2021",
    position: "Front End Developer",
    description:
      "worked as part-time Front end Developer, Development of ready-made templates for websites",
    workPlace: "DIGITAL GOAT",
  },
  {
    duration: "01/03/2021 - 07/07/2021",
    position: "Junior Front End Developer",
    description:
      "working as full-time junior vue.js front end developer, fix bugs, change interface, using vue.js, vuex",
    workPlace: "Graye (software Development Company)",
  },
  {
    duration: "01/09/2020 - 01/10/2020",
    position: "Freelancer Front End Developer",
    description: "worked as markup developer,  using html, scss and javascript",
    workPlace: "POD Agency",
  },
  {
    duration: "2016-2019",
    position: "Project Supervisor",
    description:
      "Monitor and allocate resources for concrete work, Establish effective relationship with contractors, Give direction in the efficient day-to-day operations",
    workPlace: "JSC Energo-Pro Georgia",
  },
];

export const educations = [
  {
    duration: "04/2021 - 07/2021",
    direction: "Become A Senior Developer",
    description: "The Complete Junior to Senior Web Developer Roadmap",
    source: "Udemy Online Courses",
  },
  {
    duration: "02/2021 - 08/2021",
    direction: "Data Structures + Algorithms",
    description: "Master the Coding Interview: Data Structures + Algorithms",
    source: "Udemy Online Courses",
  },
  {
    duration: "07/2020 - 09/2020",
    direction: "Front End library React.Js",
    description: "Modern React bootcamp course",
    source: "Udemy Online Courses",
  },
  {
    duration: "06/2020 - 07/2020",
    direction: "Javascript",
    description: "The Modern Javascript Bootcamp Course",
    source: "Udemy Online Courses",
  },
  {
    duration: "03/2020 - 07/2020 ",
    direction: "Javascript",
    description: "FreeCodeCamp(JavaScript, React.js)",
    source: "FreeCodeCamp.org",
  },
  {
    duration: "2010 - 2014",
    direction: "Power Engineering and Telecommunications",
    description: "Bachelors Degree",
    source: "Georgian Technical University",
  },
];

// updated 04/05/2022
